import $ from 'jquery';
import PaymentPage from './PaymentPage';
export const activatePaymentPage = () => {
  var $paymentOptionsForm = $('#payment-options-form');
  if ($paymentOptionsForm.length) {
    const paymentPage = new PaymentPage($paymentOptionsForm);
    paymentPage.orchestratePaymentOptions();
  }
};

$(async function () {
  activatePaymentPage();
});
